
document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');
  const openButton = document.querySelector('[data-drawer-open]');
  const closeButton = document.querySelector('[data-drawer-close]');

  const setDrawer = (open) => {
    if (!drawer || !overlay) return;
    drawer.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.style.overflow = open ? 'hidden' : '';
  };

  openButton?.addEventListener('click', () => setDrawer(true));
  closeButton?.addEventListener('click', () => setDrawer(false));
  overlay?.addEventListener('click', () => setDrawer(false));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setDrawer(false);
  });

  const productsToggle = document.querySelector('[data-products-toggle]');
  const productsSubmenu = document.querySelector('[data-products-submenu]');
  productsToggle?.addEventListener('click', () => {
    if (!productsSubmenu) return;
    const isOpen = productsToggle.getAttribute('aria-expanded') === 'true';
    productsToggle.setAttribute('aria-expanded', String(!isOpen));
    productsSubmenu.hidden = isOpen;
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const imageUrl = thumb.dataset.image;
        const alt = thumb.dataset.alt || '';
        if (!main || !imageUrl) return;
        main.src = imageUrl;
        main.alt = alt;
        thumbs.forEach((item) => item.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = option.dataset.price;
      const available = option.dataset.available === 'true';
      const form = select.closest('form');
      const button = form?.querySelector('[type="submit"]');
      const priceNode = document.querySelector('[data-product-price]');
      const soldOutMessage = document.querySelector('[data-sold-out-message]');
      if (priceNode && price) priceNode.textContent = price;
      if (soldOutMessage) soldOutMessage.hidden = available;
      if (button) {
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
      }
    });
  });
});
